import { Color, LuxButton } from '@lux/wardrobe-lib'
import { Dialog } from 'primereact/dialog'
import { useIntl } from 'react-intl'
import './DialogConfirmPublishPhoto.scss'

const DialogConfirmPublishPhoto = ({ totalPhoto, visible, onHide, onConfirm }) => {
    const componentClass = 'smart-modals-dialog-confirm-publish-photo'

    const intl = useIntl()

    return (
        <Dialog
            draggable={false}
            visible={visible}
            onHide={() => onHide()}
            style={{ width: '30vw' }}
            maskClassName={componentClass}
            breakpoints={{ '960px': '70vw' }}
            header={intl.formatMessage({
                id: `modals.dialog.confirm.upload.photo.title`,
                defaultMessage: 'Publishing alert',
            })}>
            <div className={`${componentClass}__content`}>
                <div className={`${componentClass}__project-name text`}>
                    {intl.formatMessage(
                        {
                            id: `modals.dialog.confirm.upload.photo.description`,
                            defaultMessage: `You’re about to publish ${totalPhoto} photos, they will be visible on PicStore in about an hour.`,
                        },
                        { totalPhoto }
                    )}
                </div>
                <div className={`${componentClass}__footer`}>
                    <LuxButton
                        text={intl.formatMessage(
                            {
                                id: 'modals.dialog.confirm.upload.photo.confirm',
                                defaultMessage: 'Publish',
                            },
                            { totalPhoto }
                        )}
                        color={Color.WARNING}
                        onClick={onConfirm}
                    />
                </div>
            </div>
        </Dialog>
    )
}

export default DialogConfirmPublishPhoto
